<script setup>
import { inject, watch } from "vue";
import { useI18n } from "vue-i18n";
import Step from "@Components/Stepper/Step.vue";
import { FormInput, FormTimepicker } from "@Components/Form";
import LanguageMenu from "@Components/LanguageMenu.vue";

const props = defineProps(["modelValue", "step"]);
defineEmits(["update:modelValue", "next", "back", "skip"]);

const { t: __ } = useI18n();
const requestsSettings = inject("requestsSettings");

watch(
    () => requestsSettings.value.url,
    (value) => {
        props.modelValue.modules.autopilot.query = value;
    },
    {
        immediate: true,
    }
);

if (requestsSettings.value.now_length === undefined) {
    requestsSettings.value.now_length = 5;
}
</script>

<template>
    <Step :step="step" @next="$emit('next')" @back="$emit('back')" @skip="$emit('skip')" class="px-4 lg:px-8 sm:px-6">
        <template #header>
            <div class="mx-auto max-w-3xl">
                <h3 class="text-4xl font-semibold leading-tight text-center text-gray-900 dark:text-white">
                    {{ __("Générez du contenu IA à partir de flux RSS importés chaque jour.") }}
                </h3>
            </div>
        </template>

        <div class="mx-auto max-w-4xl flex flex-col space-y-6">
            <FormInput
                v-model="requestsSettings.url"
                :label="__('Saisissez le lien d\'un flux RSS')"
                placeholder="https://example.com/feed"
                :errors="modelValue.getErrors('modules.autopilot.query')" />

            <div class="flex flex-wrap items-center gap-x-3 gap-y-1.5">
                <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("Publier") }}</div>
                <div class="w-20">
                    <FormInput type="number" min="0" v-model.number="requestsSettings.now_length" />
                </div>
                <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("publications immédiatement") }}</div>
            </div>

            <div class="flex flex-wrap items-center gap-x-3 gap-y-1.5">
                <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("Publier automatiquement") }}</div>
                <div class="w-20">
                    <FormInput type="number" min="1" v-model.number="modelValue.modules.autopilot.planning.per_day" />
                </div>
                <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("publications par jour entre") }}</div>
                <div class="w-24">
                    <FormTimepicker v-model="modelValue.modules.autopilot.planning.start_time" />
                </div>
                <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("et") }}</div>
                <div class="w-24">
                    <FormTimepicker v-model="modelValue.modules.autopilot.planning.end_time" />
                </div>

                <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("(UTC)") }}</div>
            </div>

            <div>
                <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("Mes publications doivent être générées en") }}</div>
                <div class="w-48 mt-2">
                    <LanguageMenu v-model="modelValue.language" />
                </div>
            </div>
        </div>
    </Step>
</template>
